import { withFormik } from 'formik'
import { compose, lifecycle, withHandlers } from 'recompose'

import { required } from 'utils/validation'

import {
  FORM_SUBMIT_STATUS,
  FORM_PROGRESS_STATUS,
  FORM_ACTION_ERROR_STATUS,
} from 'constants/form'

export default compose(
  withFormik({
    mapPropsToValues: () => ({ name: '' }),
    validate: ({ name }) => {
      const errors = {}

      if (required(name)) {
        errors.name = 'Please enter a valid group name'
      }
      
      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      const { data } = props

      data.onCreate(values)
    },
  }),
  withHandlers({
    handleFieldChange: props => (event) => {
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
      // trigger when error occured during login
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },
  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/CreateGroupForm/CreateGroupForm.enhancer.js